
class recentlyProducts  {
    constructor() {
      this.recentlyViewed = [];
      this.manageRecentlyViewed();      
    }
    
    manageRecentlyViewed(){
      let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
    
      if (getRecentlyViewed != null) {
        this.recentlyViewed = JSON.parse(getRecentlyViewed);        
        this.recentlyViewed.reverse();
       
        if (document.querySelectorAll("[data-recently-view]").length > 0) {
          document.querySelectorAll("[data-recently-view]").forEach(ele=>{
            let product_handle = ele.getAttribute('data-tab-product-handle');           
            const foundObjects = this.recentlyViewed.filter(obj => obj.handle == product_handle); 
            if (foundObjects.length > 0) {
              ele.classList.remove("d-none")
            }
          })         
        }
    
        if (this.recentlyViewed.length == 0) {
          if(document.querySelector("[emptry-tab-message]")){
            document.querySelector("[emptry-tab-message]").innerHTML = ` <div class="text-center py-4" data-empty-tab>
                <p class="h4 mb-0">We don't have any similar sheds at the moment</p>
            </div>`
          }
          
        }
     
      }
      
      if(window.globalVariables.template == 'product'){
        const productData = window.globalVariables.product;
        let requiredData = {
          id: productData.id,
          handle: productData.handle,
          title: productData.title,
          price: productData.price,
          compared_at_price: productData.compare_at_price,
          image: productData.featured_image
        }
        this.addToRecentlyViewed(requiredData);
      }
    }

   
    addToRecentlyViewed(product) {
      const productExist = this.recentlyViewed.findIndex((x) => {
        return x.id == product.id;
      });

      if (productExist == -1) {
        this.recentlyViewed.push(product)
        localStorage.setItem(
          "user_recently_viewed",
          JSON.stringify(this.recentlyViewed)
        );
      }
    }
}

new recentlyProducts()